import numeral from 'numeral';

export class MoneyService {
  static format = '0,0';

  static beautifyAmount(amount: number | string) {
    return numeral(amount).format(MoneyService.format);
  }
}
